import {
  Coupon,
  FETCH_COUPONS_REQUEST,
  FETCH_COUPONS_SUCCESS,
  FETCH_COUPONS_FAILURE,
  ACTIVATE_COUPON_REQUEST,
  ACTIVATE_COUPON_FAILURE,
  DEACTIVATE_COUPON_REQUEST,
  DEACTIVATE_COUPON_FAILURE,
  DEACTIVATE_COUPON_SUCCESS,
  ACTIVATE_COUPON_SUCCESS,
} from "@/types/coupon";
import { PaginatedApiResponse } from "@/lib/apiClient";
import { AnyAction } from "redux-saga";
import { resetStoreSpecificState } from "@/store/actions/storeActions";

export interface CouponState {
  list: Coupon[];
  pagination: PaginatedApiResponse<Coupon[]>["pagination"];
  loading: boolean;
  loadingById: Record<string, boolean>;
  error: string | null;
}

const initialState: CouponState = {
  list: [],
  pagination: {
    total: 0,
    page: 0,
    pageSize: 0,
    totalPages: 0,
  },
  loading: false,
  loadingById: {},
  error: null,
};

type Action =
  | { type: typeof FETCH_COUPONS_REQUEST }
  | {
      type: typeof FETCH_COUPONS_SUCCESS;
      payload: {
        list: Coupon[];
        pagination: PaginatedApiResponse<Coupon[]>["pagination"];
      };
    }
  | { type: typeof FETCH_COUPONS_FAILURE; payload: string }
  | { type: typeof ACTIVATE_COUPON_REQUEST; payload: string }
  | { type: typeof ACTIVATE_COUPON_SUCCESS; payload: string }
  | { type: typeof ACTIVATE_COUPON_FAILURE; payload: string }
  | { type: typeof DEACTIVATE_COUPON_REQUEST; payload: string }
  | { type: typeof DEACTIVATE_COUPON_SUCCESS; payload: string }
  | { type: typeof DEACTIVATE_COUPON_FAILURE; payload: string }
  | AnyAction;

const couponReducer = (state = initialState, action: Action): CouponState => {
  switch (action.type) {
    case FETCH_COUPONS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_COUPONS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.list,
        pagination: action.payload.pagination,
      };

    case FETCH_COUPONS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case ACTIVATE_COUPON_REQUEST:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.payload]: true,
        },
      };

    case ACTIVATE_COUPON_FAILURE:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.payload]: false,
        },
      };

    case ACTIVATE_COUPON_SUCCESS:
      return {
        ...state,
        list: state.list.map((coupon) =>
          coupon.id === action.payload ? { ...coupon, enabled: true } : coupon,
        ),
        loadingById: {
          ...state.loadingById,
          [action.payload]: false,
        },
      };

    case DEACTIVATE_COUPON_SUCCESS:
      return {
        ...state,
        list: state.list.map((coupon) =>
          coupon.id === action.payload ? { ...coupon, enabled: false } : coupon,
        ),
        loadingById: {
          ...state.loadingById,
          [action.payload]: false,
        },
      };

    case DEACTIVATE_COUPON_REQUEST:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.payload]: true,
        },
      };

    case DEACTIVATE_COUPON_FAILURE:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.payload]: false,
        },
      };

    default:
      // Handle reset store-specific state action
      if (action.type === resetStoreSpecificState.type) {
        return initialState;
      }
      return state;
  }
};

export default couponReducer;
